import type { MarkingColor, MarkingRecord } from '#shared/utils/markings/schema'
import type { MarkingColorStyle } from '~/constants/markings'
import { FALLBACK_MARKING_COLOR, MARKING_COLOR_STYLES } from '~/constants/markings'

export { MARKING_COLORS, markingSchema } from '#shared/utils/markings/schema'
export type { MarkingColor }

export type Marking = MarkingRecord

export function isMarkingColor(value: string | null | undefined): value is MarkingColor {
  return typeof value === 'string' && value in MARKING_COLOR_STYLES
}

// Accepts string so unknown or stale stored colours still render via fallback.
export function markingColorStyle(color: string): MarkingColorStyle {
  return isMarkingColor(color)
    ? MARKING_COLOR_STYLES[color]
    : MARKING_COLOR_STYLES[FALLBACK_MARKING_COLOR]
}
